import { Logger } from '@atlas/core';

const FP_OPTIONS = {
  ERROR: 'error',
  EXCLUDED: 'excluded',
  NOT_AVAILABLE: 'not available',
  audio: {
    // On iOS 11, audio context can only be used in response to user interaction.
    // We require users to explicitly enable audio fingerprinting on iOS 11.
    // See https://stackoverflow.com/questions/46363048/onaudioprocess-not-called-on-ios11#46534088
    excludeIOS11: true,
    timeout: 1000,
  },
  excludes: {
    canvas: true,
    // DNT depends on incognito mode for some browsers (Chrome) and it's impossible to detect incognito mode
    doNotTrack: true,
    // Unreliable on Windows, see https://github.com/Valve/fingerprintjs2/issues/375
    enumerateDevices: true,
    // uses js fonts already
    fontsFlash: true,
    // devicePixelRatio depends on browser zoom, and it's impossible to detect browser zoom
    pixelRatio: true,
    webgl: true,
  },
  extraComponents: [],
  fonts: {
    extendedJsFonts: false,
    swfContainerId: 'fingerprintjs2',
    swfPath: 'flash/compiled/FontList.swf',
    userDefinedFonts: [],
  },
  plugins: {
    excludeIE: false,
    sortPluginsFor: [/palemoon/i],
  },
  preprocessor: null,
  screen: {
    // To ensure consistent fingerprints when users rotate their mobile devices
    detectScreenOrientation: true,
  },
};

const resolveFingerprint = () => {
  return new Promise((resolve, reject) => {
    async function delayedCallback() {
      try {
        const Fingerprint2 = await import('fingerprintjs2');
        const components = await Fingerprint2.default.getPromise(FP_OPTIONS);

        Logger.debug('[fingerprint]', 'resolved', components); // an array of components: {key: ..., value: ...}
        resolve(components);
      } catch (e) {
        reject(e);
      }
    }

    if (window.requestIdleCallback) {
      window.requestIdleCallback(delayedCallback);
    } else {
      setTimeout(delayedCallback, 500);
    }
  });
};

export default resolveFingerprint;
